import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => (
  <motion.div 
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="flex items-center"
  >
    <motion.img
      src="/logos/humancall-logo.svg"
      alt="Logo HumanCall"
      className="w-24 h-24 aspect-square object-contain"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.7, ease: 'easeInOut' }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      draggable={false}
    />
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      className="text-2xl font-bold select-none -ml-2"
    >
      <span className="text-primary-900">Human</span>
      <span className="text-accent-600">Call</span>
    </motion.div>
  </motion.div>
);

export default Logo; 